/** Deployment flavour, served by the front door as /runtime.json.
 *  public: the internet-facing site. Call pages and Trainer; Agents and Settings stay off it.
 *  Anything else (including a missing file, as in `npm run dev`) is the full admin console. */
export let publicMode = false

export async function loadRuntime(): Promise<void> {
  try {
    const res = await fetch('/runtime.json', { cache: 'no-store' })
    if (res.ok && (res.headers.get('content-type') ?? '').includes('json')) {
      publicMode = Boolean(((await res.json()) as { public?: boolean }).public)
    }
  } catch {
    publicMode = false
  }
}

/** Test hook. */
export function setPublicMode(value: boolean): void {
  publicMode = value
}
